import { motion } from "framer-motion";
import { ArrowUpRight, PenLine } from "lucide-react";
import { useLang } from "@/lib/i18n";

const MEDIUM = "https://medium.com/@wanehamdou";

export default function Writing() {
  const { t } = useLang();
  const items = t("writing.items");
  return (
    <section id="writing" data-testid="writing-section" className="py-24 sm:py-32 border-t border-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">{t("writing.overline")}</p>
            <h2 className="font-heading font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl">
              {t("writing.h1")}<span className="text-accent">.</span>
            </h2>
          </div>
          <a
            href={MEDIUM}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="writing-medium-link"
            className="inline-flex items-center gap-2 border border-border px-5 py-3 font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground hover:border-accent hover:text-accent transition-colors duration-300"
          >
            <PenLine className="w-4 h-4" /> {t("writing.all")}
          </a>
        </div>
        <div className="border-t border-black">
          {items.map((a, i) => (
            <motion.a
              key={a.title}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`writing-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
              className="group flex items-baseline justify-between gap-6 py-6 px-2 border-b border-black hover:bg-black/[0.03] transition-colors duration-300"
            >
              <div className="flex items-baseline gap-6 min-w-0">
                <span className="font-mono text-xs text-primary shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-heading font-bold tracking-tight text-lg sm:text-xl group-hover:text-accent transition-colors duration-300">
                  {a.title}
                </h3>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground hidden sm:block">{a.date}</span>
                <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-accent group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-[color,transform] duration-300" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
